import { useIntl } from 'react-intl'
import TextButton from 'LuxKit/Button/TextButton'
import LineArrowLeftIcon from 'LuxKit/Icons/line/LineArrowLeftIcon'
import Group from 'components/utils/Group'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { rem } from 'polished'
import styled from 'styled-components'
import type { AITripPreferenceStep } from 'tripPlanner/pages/trip/types'
import type { BackButtonConfig } from 'tripPlanner/utils'

const Header = styled(Group)`
  height: fit-content;
  width: 100%;
  padding: ${rem(12)} ${rem(20)} 0 ${rem(20)};
  max-width: ${rem(640)};

  ${mediaQueryUp.tablet} {
    padding: ${rem(40)} ${rem(60)} 0 ${rem(60)};
    max-width: ${rem(720)};
  }
`

interface Props {
  step: AITripPreferenceStep
  handleClick: () => void
  backButtonConfig: BackButtonConfig
}

function GenerateTripHeader(props: Props) {
  const intl = useIntl()
  const { step, handleClick, backButtonConfig } = props

  return <Header direction="horizontal" horizontalAlign="start">
    {step === 'start' && (
      <TextButton
        kind="tertiary"
        size="large"
        startIcon={<LineArrowLeftIcon />}
        to={backButtonConfig.to}
        fit="auto"
        horizontalOutdent="start"
      >
        {backButtonConfig.label}
      </TextButton>
    )}

    {step !== 'start' && (
      <TextButton
        kind="tertiary"
        size="large"
        startIcon={<LineArrowLeftIcon />}
        onClick={handleClick}
        fit="auto"
        horizontalOutdent="start"
      >
        {intl.formatMessage({
          id: 'BEY8MsQq5TvjhAk-tv8k',
          defaultMessage: 'Back',
          description: 'Button to go back to the previous step in trip generation',
        })}
      </TextButton>
    )}
  </Header>
}

export default GenerateTripHeader
